import axiosInstance from "./global-instance";

export default axiosInstance;
